import { h, Ref } from 'preact'
import { forwardRef } from 'preact/compat'
import cls from 'classnames'
import { useContext, useMemo } from 'preact/hooks'
import { Option } from './components'
import Input from '../OtherChoiceInput'

import style from './select.scss'
import FieldsContext from 'components/business/SurveyForm/Fields/fieldsContext'
import { SelectProps } from 'components/ui/Select/type'
import useSelectProps from 'components/ui/Select/hooks/useSelectProps'

const Select = (props: SelectProps, ref?: Ref<HTMLDivElement>) => {
  const { isMultipleFields } = useContext(FieldsContext)!
  const {
    showOtherChoiceInput,
    type,
    className,
    checkedOptions,
    windowSizeMd,
    options,
    optionRef,
    handleOptionChange,
    handleOtherValueChange,
    displayOrder,
    max,
  } = useSelectProps(props)

  const paddingBottom = useMemo(() => {
    if (isMultipleFields) {
      return 0
    }
    return 16
  }, [isMultipleFields])

  const disabled = useMemo(() => {
    return !!(max && (checkedOptions?.length ?? 0) >= max)
  }, [checkedOptions, max])

  return (
    <div className={className} ref={ref}>
      <div ref={optionRef} style={{ paddingBottom }}>
        {displayOrder.map((optionIndex) => {
          const option = options[optionIndex]
          const checked = checkedOptions?.includes(option.value)
          return (
            <div
              key={option.value}
              className={cls(style.optionLabel, windowSizeMd && style.optionWeb, checked && style.checked)}
              disabled={!checked && disabled}
            >
              <Option
                disabled={!checked && disabled}
                checked={checked}
                value={option.value}
                type={type}
                onChange={(value: string, checked: boolean) => handleOptionChange(value, checked, option.type)}
              >
                {option.label}
              </Option>
            </div>
          )
        })}
        {showOtherChoiceInput && <Input className={style.otherInput} onChange={handleOtherValueChange} />}
      </div>
    </div>
  )
}

export default forwardRef(Select)
